<template>
    <div>
        <ValidationObserver slim ref="form">
            <form @submit.prevent="onSubmit">
                <p class="text">&nbsp;<!-- Pour toute autre question : --></p>
                <div class="col2 form-item" v-show="!success">
                    <p>
                        <label for="prenom">Prénom*</label>
                        <ValidationProvider slim name="field_prenom" rules="required" v-slot="{ classes, errors }">
                            <input type="text" name="prenom" id="prenom" :class="classes" v-model="item.prenom" />
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>

                    <p>
                        <label for="nom">Nom*</label>
                        <ValidationProvider slim name="field_nom" rules="required" v-slot="{ classes, errors }">
                            <input type="text" name="nom" id="nom" :class="classes" v-model="item.nom" />
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>
                </div>

                <div class="col1 form-item" v-show="!success">
                    <p>
                        <label for="adresse">Adresse de livraison*</label>
                        <ValidationProvider slim name="field_adresse_support" rules="required" v-slot="{ classes, errors }">
                            <input type="text" name="adresse" id="adresse" :class="classes" v-model="item.adresse" />
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>
                </div>

                <div class="col2 form-item" v-show="!success">
                    <p>
                        <label for="ville">Ville de livraison*</label>
                        <ValidationProvider slim name="field_ville_support" rules="required" v-slot="{ classes, errors }">
                            <input type="text" name="ville" id="ville" :class="classes" v-model="item.ville" />
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>

                    <p>
                        <label for="cp">Code postal de livraison*</label>
                        <ValidationProvider slim name="field_code_postal_support" rules="required" v-slot="{ classes, errors }">
                            <input type="text" name="cp" id="cp" :class="classes" v-model="item.cp" />
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>
                </div>


                <div  class="form-item col2 ckeckbox-list" v-for="(support, key) in item.supports" v-show="!success">
                    <p>
                        <ValidationProvider slim :name="'field_support_' + key"
                                            :rules="{ required: { allowFalse: false } }" v-slot="{ classes, errors }" v-if="support.quantite">
                            <input type="checkbox" name="support" :id="'support_' + support.name" :value="support.name"
                                   v-model="support.checked"
                                   @change="checkedSupport($event, support)" />
                            <label :for="'support_' + support.name"><span>{{ support.name }}</span></label>
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                        <template v-else>
                            <input type="checkbox" name="support" :id="'support_' + support.name" :value="support.name"
                                   v-model="support.checked"
                                   @change="checkedSupport($event, support)" />
                            <label :for="'support_' + support.name"><span>{{ support.name }}</span></label>
                        </template>
                    </p>
                    <p>
                        <label for="quantite">Quantité souhaitée*</label>
                        <ValidationProvider slim :name="'field_quantite_support_' + key"
                                :rules="`${support.checked ? 'required' : ''}`" v-slot="{ classes, errors }">
                            <select id="quantite" name="quantite" :class="classes" v-model="support.quantite">
                                <option value="null">Quantité souhaitée*</option>
                                <option :value="i" v-for="i in 10">{{ i }}</option>
                            </select>
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>
                </div>


                <div class="col1 form-item" v-show="!success">
                    <p>
                        <textarea placeholder="Message" v-model="item.message"></textarea>
                    </p>
                </div>

                <div class="recaptcha" v-show="!success">
                    <vue-recaptcha :sitekey="recaptcha_site_key"
                                   ref="googleRecaptcha"
                                   @verify="markRecaptchaAsVerified"
                    ></vue-recaptcha>
                    <p class="error-txt" v-if="recaptchaError">{{ recaptchaError }}</p>
                </div>

                <div class="form-item" v-show="!success">
                    <input type="submit" name="submit" id="submit" value="envoyer" />
                </div>

                <p class="error-txt" v-if="error">{{ error }}</p>
                <p class="success-txt" v-if="success" v-html="success"></p>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import User from "../../services/User";
import Support from "../../services/Support";

export default {
    props: {
        recaptcha_site_key: {},
        all_supports: {
            type: Array
        },
    },
    components: {VueRecaptcha},
    data() {
        return {
            error: null,
            success: null,
            recaptchaVerified: false,
            recaptchaError: null,
            item: {
                prenom: null,
                nom: null,
                adresse: null,
                ville: null,
                cp: null,
                supports: [],
                message: null,
            }
        }
    },
    created() {
        User.me().then((user) => {
            this.item.prenom = user.field_prenom;
            this.item.nom = user.field_nom;
            this.item.adresse = user.field_etablissement.field_adresse;
            this.item.ville = user.field_etablissement.field_ville;
            this.item.cp = user.field_etablissement.field_code_postal;
        });

        for (let key in this.all_supports) {
            this.item.supports.push({
                name: this.all_supports[key].name,
                quantite: null,
                checked: false,
            });
        }
    },
    mounted() {

    },
    methods: {
        markRecaptchaAsVerified(response) {
            this.recaptchaVerified = true;
            this.item.recaptcha_token = response;
        },
        onSubmit() {
            this.error = this.success = this.recaptchaError = null;
            this.$refs.form.validate().then(success => {

                if (!this.recaptchaVerified) {
                    this.recaptchaError = 'Merci de valider le Captcha.';
                    success = false;
                }

                if (!success) {
                    return;
                }

                this.sendContact();
            });
        },
        sendContact() {
            Support.send(this.item).then((response) => {
                this.success = response.success;

                // Redirect
                // this.success = this.success + "<br />Vous allez être rediriger vers la page d\'accueil dans quelques secondes...";
                // setTimeout(() => {
                //     window.location.href = window.drupalSettings.path.baseUrl;
                // }, 3000);
            }).catch((error) => {
                this.error = error.error;

                // reset Re-captcha
                this.recaptchaVerified = false;
                this.$refs.googleRecaptcha.reset();
            });
        }
    }
}
</script>
